var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wc-section-title',{attrs:{"title":"Tasks"}}),_c('router-view',{attrs:{"loading":_vm.isLoading,"tasks":_vm.tasks,"profiles":_vm.profiles},on:{"update":_vm.update,"create":_vm.create,"deleteTask":_vm.deleteTask}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }